import type { TestConnectionResult } from "@/api/client";
import { useTestDatalake } from "@/api/import/datalakes";
import TestConnectionCard from "@/components/TestConnectionCard";
import { useDatalakeContext } from "@/pages/import/DatalakesPage/DatalakePage";

const DatalakeConnection = () => {
  const { datalake } = useDatalakeContext();
  const testDatalake = useTestDatalake();

  const test: TestConnectionResult = testDatalake.isPending
    ? { status: "processing" }
    : (testDatalake.data ?? { status: undefined });

  return (
    <TestConnectionCard
      test={test}
      request={{ status: undefined }}
      // TestConnectionCard only labels sources and destinations. A datalake is where extracted
      // records land, so "destination" is the closer fit for its body copy.
      connectionType="destination"
      usesPreparedConnection={false}
      onTestConnection={() => testDatalake.mutate(datalake.id)}
    />
  );
};

export default DatalakeConnection;
